import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";

export default function Layout() {
  const location = useLocation();

  // Hide navbar/footer on the homepage
  const simplePage = location.pathname === "/" || "/behind-on-taxes" ;


  return (
    <>
      {!simplePage && <Navbar />}

      <Outlet />

      {!simplePage  && (
        <footer className="text-center text-gray-900 p-2 bg-white">
          <div className="mx-auto max-w-4xl py-10 text-center md:text-left">
            <div className="text-center px-1 text-sm italic leading-tight">
              unitedtaxattorneys.com is not a broker, direct lender, or
              insurance provider, nor is it affiliated with any governmental
              organizations. The informational forms provided on
              unitedtaxattorneys.com’s site do not constitute an application for
              debt settlement, nor is the information provided used to
              pre-qualify you with any lenders. There is no guarantee that you
              will be approved for rates displayed.
            </div>

            <div className="text-center mt-2 text-gray-700 text-sm">
              <a href="/terms-conditions" className="hover:underline">
                Terms &amp; Conditions
              </a>

              <a href="/privacy-policy" className="ml-2 hover:underline">
                Privacy Policy
              </a>

              <a href="/cookie-policy" className="ml-2 hover:underline">
                Cookie Policy
              </a>
            </div>
          </div>

          <div className="text-center p-2">
            <div className="text-gray-700 font-semibold text-sm">
              © 2025 unitedtaxattorneys.com. All Rights Reserved.
            </div>
          </div>
        </footer>
      )}
    </>
  );
}